module.exports = __webpack_public_path__ + "static/img/historyDefault.10c7f26c.png";